// Single source of truth for Features view constants.
// Copied from FeatureMasterView.jsx so the V2 page can drop the legacy import.

export const ASSET_OPTIONS       = ["Stock", "MF", "BOND", "EKYC", "Commodity", "Currency"];
export const IP_TYPE_OPTIONS     = ["Default", "Custom Development", "Customer IP", "Roadmap"];
export const PLATFORM_OPTIONS    = ["Web", "Mobile", "API", "Retail API"];
export const CUST_STATUS_OPTIONS = ["Yet to Implement", "In Dev", "In UAT", "In Live", "Not Applicable"];
export const TP_DATA_TYPE_OPTS   = ["REST", "WebSocket", "FTP", "SFTP", "Polling", "Batch"];
export const DEP_TYPE_OPTIONS    = [
  "Documentation Required",
  "Clarification Needed",
  "Blocker",
  "External Dependency",
  "Internal Coordination",
];

// Sub-feature creation defaults: teams whose name contains any of these
// keywords are pre-selected on the "Implementation Teams" mapping.
export const DEFAULT_REQUIRED_TEAM_KEYWORDS = ["api", "mobile", "web", "qa"];

// Sub-feature boolean flag fields rendered as chip toggles.
export const SUB_FEATURE_FLAGS = [
  { key: "is_BOD",       label: "BOD" },
  { key: "is_scheduled", label: "Scheduled" },
  { key: "is_EOD",       label: "EOD" },
  { key: "is_internal",  label: "Internal" },
];
